module.exports = __webpack_public_path__ + "img/icon-info.d19f62fc.svg";